<div class="modal-body">
	<div class="modal-header">
		<h2 class="modal-title" [innerHtml]="title"></h2>
		<button type="button" class="btn btn-close" aria-label="Cancel" (click)="close()" data-cy="closeModal">
			<i class="fal fa-xmark"></i>
		</button>
	</div>
	@if (formLoaded) {
		<form (ngSubmit)="submit($event)" class="fade-in">
			<div class="modal-body">
				<div class="char-data__group">
					<rl-form-table-row [labelText]="'Section Name'" [required]="true"
						[class.has-error]="form.controls.groupLabel.touched && form.invalid && form.controls.groupLabel.value === ''">
						<ng-template rlFormTableControl>
							<rl-text-input [formControl]="form.controls.groupLabel"
								[dataLabel]="'textInputSectionName'"></rl-text-input>
						</ng-template>
						@if (form.controls.groupLabel.touched && form.invalid && form.controls.groupLabel.value === '') {
							<ng-template rlFormTableMessage>
								Section Name is required.
							</ng-template>
						}
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Description'">
						<ng-template rlFormTableControl>
							<rl-text-input [formControl]="form.controls.groupDescription"
								[dataLabel]="'textInputDescription'"></rl-text-input>
						</ng-template>
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Expand Group on Load'">
						<ng-template rlFormTableControl>
							<rl-checkbox-input [label]="!!form.controls.expandIndicator.value ? 'Yes' : ''"
								[formControl]="form.controls.expandIndicator"
								[dataLabel]="'checkboxInputExpandGroupYes'" class="d-block py-1"></rl-checkbox-input>
						</ng-template>
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Expand Contacts on Load'">
						<ng-template rlFormTableControl>
							<rl-checkbox-input [label]="!!form.controls.expandGroupIndicator.value ? 'Yes' : ''"
								[formControl]="form.controls.expandGroupIndicator"
								[dataLabel]="'checkboxInputExpandContactsYes'" class="d-block py-1"></rl-checkbox-input>
						</ng-template>
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Visibility'">
						<ng-template rlFormTableControl>
							<rl-dropdown-single [(formControl)]="form.controls.visibilityIndicator"
								[options]="visibilityList" [showEmptyOption]="true"
								[dataLabel]="'selectDropdownVisibility'">
							</rl-dropdown-single>
						</ng-template>
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'System Indicator'"
						[class.has-error]="form.controls.systemIndicator.value < 0 && form.invalid">
						<ng-template rlFormTableControl>
							<rl-number-input [formControl]="form.controls.systemIndicator" [min]="0"
								[dataLabel]="'numberInputSystemIndicator'"></rl-number-input>
						</ng-template>
						@if (form.controls.systemIndicator.value < 0 && form.invalid) {
							<ng-template rlFormTableMessage>
								Negative values are invalid.
							</ng-template>
						}
					</rl-form-table-row>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-light" (click)="close()" data-cy="cancelButton">Cancel</button>
				<button class="btn btn-success" [disabled]="form.invalid || isSaving" (click)="submit($event)"
					data-cy="saveButton">@if (isSaving) {
						<i class="fal fa-spinner fa-spin me-1"></i>
					}Save</button>
			</div>
		</form>
	} @else {
		<div class="modal-body fade-in">
			<rl-form-placeholder [numRows]="3"></rl-form-placeholder>
		</div>
	}
</div>